
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const skugroupApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listSKUGroups: builder.query ({
      query: (params) => `v2/skugroup/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["SKUGroup"]
    }),
    getSKUGroup: builder.query ({
      query: (skugroup_id) => `v2/skugroup/${skugroup_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["SKUGroup"]
    }),

    updateSKUGroup: builder.mutation ({
      query: ({skugroup_id, data}) => ({
        url: `v2/skugroup/${skugroup_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["SKUGroup"]
    }),
    deleteSKUGroup: builder.mutation ({
      query: (skugroup_id) => ({
        url: `v2/skugroup/${skugroup_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["SKUGroup"]
    }),
    createSKUGroup: builder.mutation ({
      query: (data) => ({
        url: `v2/skugroup/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["SKUGroup"]
    }),
  })
})


export const {
  useListSKUGroupsQuery,
  useLazyListSKUGroupsQuery,
  useGetSKUGroupQuery,
  useLazyGetSKUGroupQuery,

  useUpdateSKUGroupMutation,
  useDeleteSKUGroupMutation,
  useCreateSKUGroupMutation
} = skugroupApi
